import {inject, injectable} from 'inversify'
import type {ILoggerService} from '@/src/ports/services/logger'
import {DI} from '@/src/config/di/types'
import type {IErrorReporter} from '@/src/ports/services/monitoring'

/**
 * Silent Logger Service
 *
 * Production-safe logger that suppresses all output except errors.
 * Errors are sent to crash reporter instead of console.
 */
@injectable()
export class SilentLoggerService implements ILoggerService {
  @inject(DI.IErrorReporter)
  private errorReporter!: IErrorReporter

  debug(): void {
    // Silent in production
  }

  info(): void {
    // Silent in production
  }

  warn(): void {
    // Silent in production
  }

  error(message: string, error?: unknown, context?: Record<string, unknown>): void {
    // Send to crash reporter with context
    if (error instanceof Error) {
      this.errorReporter.capture(error, {
        message,
        ...context,
      })
    } else if (error) {
      this.errorReporter.capture(new Error(message), {
        originalError: String(error),
        ...context,
      })
    } else {
      this.errorReporter.capture(new Error(message), context)
    }
  }
}
